import { useContext } from 'react';
import { UnifiedPermissionsContext } from './context';

export const useAuth = () => {
  const context = useContext(UnifiedPermissionsContext);
  if (!context) {
    throw new Error('useAuth must be used within a UnifiedPermissionsProvider');
  }

  return {
    session: context.session,
    user: context.user,
    authReady: context.authReady,
    isAuthenticated: context.isAuthenticated,
    isLoading: !context.authReady,
    signIn: context.signIn,
    signUp: context.signUp,
    signOut: context.signOut,
    updateUserMetadata: context.updateUserMetadata,
  };
};
